import { addDays, eachDayOfInterval, endOfMonth, startOfMonth } from 'date-fns';

export const getMonthlyPlanningDates = (year: number, month: number) => {
  const monthDate = new Date(year, month, 15);
  const monthDays = eachDayOfInterval({
    start: startOfMonth(monthDate),
    end: endOfMonth(monthDate),
  });
  const firstDayOffset = (monthDays[0].getDay() + 6) % 7;

  if (monthDays.length % 7 !== 0) {
    // If month can't be divided by full weeks evenly
    if (monthDays.length % 7 !== 0) {
      // Ensure the first day of the month is Monday
      if (monthDays[0].getDay() !== 1) {
        let offset = firstDayOffset; // Calculate offset to the previous Monday
        while (offset > 0) {
          monthDays.unshift(addDays(monthDays[0], -1));
          offset -= 1;
        }
      }

      // Ensure the last day of the month is Sunday
      if (monthDays[monthDays.length - 1].getDay() !== 0) {
        let offset = 7 - monthDays[monthDays.length - 1].getDay(); // Calculate offset to the next Sunday
        while (offset > 0) {
          monthDays.push(addDays(monthDays[monthDays.length - 1], 1));
          offset -= 1;
        }
      }
    }
  }

  return { monthDays, firstDayOffset };
};
